import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'fcfModeSelection.title',
    defaultMessage: 'Set your trial visit limit',
  },
  subtitle: {
    id: 'fcfModeSelection.subtitle',
    defaultMessage: 'Select the ClassPass trial visit limit for this venue*',
  },
  onePerVenueTitle: {
    id: 'fcfModeSelection.onePerVenueTitle',
    defaultMessage: 'One trial visit per venue',
  },
  onePerVenueDescription: {
    id: 'fcfModeSelection.onePerVenueDescription',
    defaultMessage: 'A trial user can attend one class at each of your venues.',
  },
  onePerVenueExample: {
    id: 'fcfModeSelection.onePerVenueExample',
    defaultMessage:
      'Example: If you have 3 venues, a trial user can attend up to 3 classes during their trial period — one per venue.',
  },
  onePerOrgTitle: {
    id: 'fcfModeSelection.onePerOrgTitle',
    defaultMessage: 'One trial visit across all your venues',
  },
  onePerOrgDescription: {
    id: 'fcfModeSelection.onePerOrgDescription',
    defaultMessage: 'A trial user can attend one class total during their trial, across all of your venues.',
  },
  onePerOrgExample: {
    id: 'fcfModeSelection.onePerOrgExample',
    defaultMessage:
      'Example: If you have 3 venues, a trial user can attend 1 class total during their trial (at any one of your venues).',
  },
  recommendedLabel: {
    id: 'fcfModeSelection.recommendedLabel',
    defaultMessage: 'Recommended',
  },
  applyToAllVenuesLabel: {
    id: 'fcfModeSelection.applyToAllVenuesLabel',
    defaultMessage: 'Apply this setting to all venues I manage',
  },
  venuesYouManageLabel: {
    id: 'fcfModeSelection.venuesYouManageLabel',
    defaultMessage: 'Venues you manage',
  },
  disclaimerText: {
    id: 'fcfModeSelection.disclaimerText',
    defaultMessage:
      '*This setting applies to ClassPass trial users only. Paid subscriber booking eligibility is unchanged. "Apply this setting to all venues I manage" updates this setting for all venues you have account access to manage. ClassPass does not guarantee that trial booking limits will be enforced in all circumstances. Trial visits are subject to ClassPass policies and the <a>Trial Program Terms</a> control.',
  },
  bulkFCFModeConfirmTitle: {
    id: 'venue-page.bulk-fcf-mode-confirm.title',
    defaultMessage: 'Are you sure you want to apply this change to all venues?',
  },
  bulkFCFModeConfirmBody: {
    id: 'venue-page.bulk-fcf-mode-confirm.body',
    defaultMessage: 'This will update the FCF mode for all your managed venues.',
  },
  bulkFCFModeConfirmAccept: {
    id: 'venue-page.bulk-fcf-mode-confirm.accept',
    defaultMessage: 'Apply to all',
  },
  bulkFCFModeConfirmCancel: {
    id: 'venue-page.bulk-fcf-mode-confirm.cancel',
    defaultMessage: 'Cancel',
  },
});
